import { render, staticRenderFns } from "./profileFriendsChatUserCard.vue?vue&type=template&id=6f46ff8e&scoped=true&"
import script from "./profileFriendsChatUserCard.vue?vue&type=script&lang=js&"
export * from "./profileFriendsChatUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46ff8e",
  null
  
)

export default component.exports